export default class Constants {
    public static readonly MESSAGE_TYPE_DANGER: string = "danger";
    public static readonly MESSAGE_TYPE_SUCCESS: string = "success";
    public static readonly MESSAGE_TYPE_WARNING: string = "warning";
    public static readonly MESSAGE_TYPE_INFO: string = "info";
}



// WEBPACK FOOTER //
// ./src/Components/MessageToaster/Constants.tsx